import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';


import {Dropdown} from 'primereact/dropdown';
import Messages from '../../../shared/UI/Messages/Messages';
import {Toast} from 'primereact/toast';
import { DROPDOWN_CONFIG, ORG_SUBMENU_ID } from '../../../shared/Config';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddOrganizationUnit extends Component {
    state = {
        type: 'add',
        Id : null,
        OrgId : null,
        OrgType: null, 
        OrgNo : '',
        Name: '',
        Description:'',
        FocalPointEmployeeId : null,
        ManagedBy: null,
        Director: null,
        DivisionChief: null,
        ReportingToOrgid:null,
        ReportingToOrgType: null,
        Isactive : true,
        Createdby : (this.props.loggedUserDetail.userName) ?? 'Admin',
        Createddate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        ConcOrgId : null,
        ConcName : '',
        touch : false
    }



    componentDidMount(){
       
        this.props.getMasterKeywordList('OrgType'); 
 
        setTimeout(()=> {
            this.props.getMasterKeywordList('Employee');
        }, 1000)

        this.props.fetchPositionLists();

        this.props.getMasterTableList('GetOrgUnit1');   

        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },5000)
            
        }
        this.getAccess = HASACCESS(ORG_SUBMENU_ID);

    }

    fetchSingleProcess = () =>{
   
        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];

        if(this.props.tableLists.orgUnitList!==undefined) {
            storageItems = this.props.tableLists.orgUnitList;
        }
        if(storageItems){
            let filterData = storageItems.filter(list => {
                return list.orgId === id;
            }).reduce((arr,el) => {
                return el;
            },{});
    

            if(filterData){
             
                var data = {
                    type:type,
                    Id : filterData.id,
                    OrgId : filterData.orgId,
                    OrgType: filterData.orgType.toString(),
                    OrgNo : filterData.orgNo,
                    Name: filterData.name,
                    Description: filterData.description,
                    FocalPointEmployeeId : filterData.focalPointEmployeeId,
                    ManagedBy: filterData.managedBy,
                    DivisionChief: filterData.divisionchief,
                    Director: filterData.director,
                    ReportingToOrgid : filterData.reportingToOrgid,
                    ReportingToOrgType: filterData.reportingToOrgType,
                    Isactive : filterData.isactive,
                    Createdby : filterData.createdby,
                    Createddate : filterData.createddate,
                    CompanyId: filterData.companyId,
                    ConcOrgId : filterData.concOrgId,
                    ConcName : filterData.concName
                }

                this.setState(data);
                
            }
        }

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    add = () => {
         if(this.state.OrgType === null){
            this.growl.show({severity: 'error', summary: null, detail: 'OrgType is required'});
            return;
         }else if(this.state.OrgNo === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'OrgNo is required'});
            return;
         }else if(this.state.Name === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'Name is required'});
            return;
         }else if(this.state.ManagedBy === null){
            this.growl.show({severity: 'error', summary: null, detail: 'ManagedBy is required'});
            return;
        }else if(this.state.Director === null){
            this.growl.show({severity: 'error', summary: null, detail: 'Director is required'});
            return;
         }else if(this.state.DivisionChief === null){
            this.growl.show({severity: 'error', summary: null, detail: 'Chief is required'});
            return;         
         }else if(this.state.ReportingToOrgid === null){
            this.growl.show({severity: 'error', summary: null, detail: 'ReportingToOrgid is required'});
            return;
         }

        var data = {
            OrgType: this.state.OrgType.toString(),
            OrgNo : this.state.OrgNo,
            AboveOrgId: null,
            Name: this.state.Name,
            Description: this.state.Description,
            FocalPointEmployeeId : this.state.FocalPointEmployeeId,
            Director : this.state.Director, 
            DivisionChief : this.state.DivisionChief,
            ManagedBy: this.state.ManagedBy,
            ReportingToOrgid : this.state.ReportingToOrgid,
            ReportingToOrgType: this.state.ReportingToOrgType,
            Isactive : this.state.Isactive,
            CompanyId: this.state.CompanyId,
            ConcOrgId : this.state.ConcOrgId,
            ConcName : this.state.ConcName
        }
  
       
        if(this.state.type === 'add'){
            data.Createdby = this.state.Createdby;
            data.Createddate = this.state.Createddate;
        }

        if(this.state.type === 'edit'){
            data.Id = this.state.Id;
            data.OrgId = this.state.OrgId;
            data.Updatedby = (this.props.loggedUserDetail.userName) ?? 'Admin';
            data.Updateddate = new Date();
        }

        this.props.processDynamicData('OrgUnit',this.state.type,data,'GetOrgUnit1');

    }

    resetData = () => {
        var data = {
            OrgType: null, 
            OrgNo : '',
            Name: '',
            Description:'',
            FocalPointEmployeeId : null,
            ManagedBy: null,
            ReportingToOrgid:null,
            ReportingToOrgType: null,
            Isactive : true,
            ConcOrgId : null,
            ConcName : null
        }
        this.setState(data);
    }
  
    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/organization-unit/',this.props);
        }

        let releventOption = [];
        if(this.props.GetEmployeedropdown && this.props.GetEmployeedropdown.length > 0) {
            releventOption = this.props.GetEmployeedropdown;
        }
 
        let tableData = [];
        if(this.props.tableLists.orgUnitList!==undefined) {
            tableData = this.props.tableLists.orgUnitList.map(list => {
                return {label : list.name, value : list.orgId, id:list.orgNo}
            });
        }

        let OrgType = [];
        if(this.props.OrgType && this.props.OrgType.length > 0) {
            OrgType = this.props.OrgType;
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        let isEnabled = (this.state.selectedProcess!==null) && (this.state.selectedPath!==null) && (this.state.fromDate!=='') && (this.state.toDate!=='') && (this.state.touch ===true)
        return (
            <div className="p-grid">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Organization Unit</h1>
                  
                        <div className="p-grid mt1">
                            
                            <div className="p-col-6 p-offset-3">   
                                

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Organization Number  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="OrgNo" value={this.state.OrgNo}  placeholder="Organization Number" onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Name  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="Name" value={this.state.Name}  placeholder="Name" onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Description </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputTextarea rows={3} cols={30} className="width100"  value={this.state.Description}  name="Description" placeholder="Description" autoResize={true} onChange={this.change} />
                                </div>



                                <div className="p-col-12">
                                    <label htmlFor="acSimple">ManagedBy <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">

                                    <Dropdown placeholder="Select ManagedBy" name="ManagedBy" value={this.state.ManagedBy} options={this.props.positionList} onChange={this.change} className="p-col-12" {...DROPDOWN_CONFIG}/>

                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Director <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">

                                    <Dropdown placeholder="Select Director" name="Director" value={this.state.Director} options={this.props.positionList} onChange={this.change} className="p-col-12" {...DROPDOWN_CONFIG}/>

                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Chief<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">

                                    <Dropdown placeholder="Select Chief" name="DivisionChief" value={this.state.DivisionChief} options={this.props.positionList} onChange={this.change} className="p-col-12" {...DROPDOWN_CONFIG}/>

                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Reporting To Org Unit <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Reporting To Org Unit" options={tableData} name="ReportingToOrgid" value={this.state.ReportingToOrgid} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                </div>

                                

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Organization Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Organization Type" options={OrgType} name="OrgType" value={this.state.OrgType} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                </div>	
                                

                            </div>

                            <div className="p-col-12">
                                    <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/organization-unit/"} />
                                </div>
                        </div>
                   

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success:state.master.success,
        tableLists : state.master.tableLists,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        OrgType : (state.keyword.OrgType!==undefined) ? state.keyword.OrgType : [],
        positionList : state.master.positionList,
        
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPositionLists : () => dispatch(actions.fetchPositionLists()),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(AddOrganizationUnit);